import { 
    gql, 
  useQuery 
} from "@apollo/client";
import { QueryRefundOverviewAdminArgs, RefundOverviewAdminQueryQuery } from "../../../../../schemaTypes";

export const refundOverviewAdminQuery = gql`
  query RefundOverviewAdminQuery(
    $duration: String!
  ) {
    refundOverviewAdmin(
      duration: $duration 
    ) {
        totalRefunds
        pendingRefunds
        totalPendingRefundValue
    }
  }
`;

export interface WithRefundOverviewAdmin {
  totalRefunds: number;
  pendingRefunds: number;
  totalPendingRefundValue: number;
}

interface Props {
  variables: QueryRefundOverviewAdminArgs;
  children: (data: WithRefundOverviewAdmin) => React.ReactElement | null;
}

export const RefundOverviewAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    RefundOverviewAdminQueryQuery,
    QueryRefundOverviewAdminArgs
  >(refundOverviewAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const totalRefunds = data?.refundOverviewAdmin.totalRefunds|| 0;
  const pendingRefunds = data?.refundOverviewAdmin.pendingRefunds || 0;
  const totalPendingRefundValue = data?.refundOverviewAdmin.totalPendingRefundValue || 0;


  return children({
        totalRefunds,
        pendingRefunds,
        totalPendingRefundValue
  });
};